<app-order-summary-sheet [order]="order"></app-order-summary-sheet>

<mat-card class="wrapperData">
    <div class="back">
        <button mat-stroked-button class="large" color="primary" (click)="onBack()" aria-label="Back"
            [appDisabledOnWorking]="onBackWorking$"><mat-icon>keyboard_backspace</mat-icon> <span i18n="@@PackageOrder.backButton">Back</span></button>
    </div>
    <div class="scan">
        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box"
            [fullScreen]="true">
            <p class="spinner" i18n="@@PackageOrder.loadingSpinner"> Loading... </p>
        </ngx-spinner>
        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin"
            [name]="spinnerNameCloseBox" [fullScreen]="true">
            <p class="spinner" i18n="@@PackageOrder.closeBoxSpinner"> Close box ... </p>
        </ngx-spinner>
        <app-scan-input class="scanInput" (onId)="onScan($event)" [disabled]="isScanDisabled"></app-scan-input>
    </div>
    <div class="scanText" *ngIf="stats !== undefined">SKU:
        <strong>{{stats.skuPacking}}</strong>/<strong>{{stats.skuTotal}}</strong> Units:
        <span><strong>{{stats.pending}}</strong>/<strong>{{stats.total}}</strong></span>
    </div>
    <div class="actions">
        <div class="buttonActions">
        <button mat-stroked-button class="icon-button-large" color="primary" (click)="onPrint()" [disabled]="isPrintDisabled"
            [appDisabledOnWorking]="progres$" aria-label="Print"><mat-icon>print</mat-icon> <span i18n="@@PackageOrder.printButton">Print</span></button>
        <button mat-stroked-button class="icon-button-large" color="primary" (click)="onIncident()" [disabled]="isIncidentDisabled"
            [appDisabledOnWorking]="progres$" aria-label="Incident" data-test-id="buttonIncident"
            [matBadge]="incidentNumber" matBadgeColor="warn"
            [matBadgeHidden]="hideIncidentBadge"><mat-icon>warning</mat-icon> <span i18n="@@PackageOrder.incidentButton">Incident</span></button>
        <button mat-stroked-button class="icon-button-large" color="primary" (click)="onRestartBox()" aria-label="restart"
            [disabled]="isRestartDisabled" [appDisabledOnWorking]="progres$"
            data-test-id="buttonRestartBox"><mat-icon>restart_alt</mat-icon> <span i18n="@@PackageOrder.restartButton">Restart</span></button>
        <button mat-stroked-button class="icon-button-large" color="warn"
            [disabled]="isInstructionsDisabled" [appDisabledOnWorking]="progres$" aria-label="Instructions"
            data-test-id="buttonInstructions"
            [matTooltip]="instructionsTooltipText" 
            [matTooltipDisabled]="isInstructionsDisabled || !instructionsTooltipShown"
            matTooltipPosition="above"
            matTooltipClass="tooltip-red"
            #instructionsTooltip="matTooltip"
            (click)="onInstructions(); hideInstructionsTooltip()">
            <mat-icon>integration_instructions</mat-icon>
            <span i18n="@@PackageOrder.instructionsButton">Instructions</span></button>
        </div>
    </div>

    <mat-card class="orderTable mat-elevation-z8" tabindex="0">
        <app-order-table [orderLines]="packedState.orderLineList | sortOrderLinePackedVo"
            (onSelected)="onChangeSelected($event)" [selectedItem]="lineKey" class="orderList"></app-order-table>

    </mat-card>
    <div class="toolbar">

        <mat-toolbar>
            <mat-toolbar-row>
                <div class="boxType">
                    <span><strong class="boxtypeTitle" i18n="@@PackageOrder.boxTitle">Box </strong> </span>
                    <ng-container *ngIf="boxModelId$ | async as boxModelId; else notSelect">
                        <span data-test-id="boxTypeValue">{{boxModelId._id}}</span>
                        <span class="boxId">&nbsp;/ {{boxModelId.boxModelId}}</span>
                    </ng-container>
                    <ng-template #notSelect>&nbsp;<span data-test-id="boxTypeValue" i18n="@@PackageOrder.notSelected">not selected</span></ng-template>
                </div>
            </mat-toolbar-row>
            <mat-toolbar-row class="largeQr">
                <button mat-stroked-button class="largeQr buttonToolbar" color="primary" (click)="onCloseBox()"
                    aria-label="closeBox" [disabled]="isCloseDisabled" [appDisabledOnWorking]="progres$"
                    data-test-id="buttonCloseBox">
                    <!-- <mat-icon>inventory_2</mat-icon>  -->
                    <qrcode *ngIf="!isCloseDisabled" [qrdata]="'##CLOSE#'" [width]="60" [errorCorrectionLevel]="'M'" style="height: 60px;"></qrcode>
                    <span i18n="@@PackageOrder.closeButton">Close</span>
                </button>
            </mat-toolbar-row>
            <mat-toolbar-row>
                <ng-container *ngIf="boxModelId$ | async; else notSelectBoxType">
                    <button mat-stroked-button class="large buttonToolbar" color="primary" (click)="onChangeBoxType()"
                        [appDisabledOnWorking]="progres$" aria-label="change box type" [disabled]="isChangeBoxDisabled"
                        data-test-id="buttonChangeBox"><mat-icon>swap_horiz</mat-icon> <span i18n="@@PackageOrder.changeBoxType">Change Box Type</span></button>
                </ng-container>
                <ng-template #notSelectBoxType>
                    <button mat-stroked-button class="large buttonToolbar" color="primary" (click)="onSelectBoxType()"
                        [appDisabledOnWorking]="progres$" aria-label="change box type"
                        data-test-id="buttonChangeBox"><mat-icon>archive</mat-icon> <span i18n="@@PackageOrder.selectBoxType">Select Box Type</span></button>
                </ng-template>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
</mat-card>

<mat-expansion-panel class="boxPacked" tabindex="0">
    <mat-expansion-panel-header>
        <mat-panel-title i18n="@@PackageOrder.packedTitle">Packed </mat-panel-title>
        <mat-panel-description>
            <!-- Inform the date you wish to travel
        <mat-icon>date_range</mat-icon> -->
        </mat-panel-description>
    </mat-expansion-panel-header>

    <ng-container *ngIf="packedState.packedList === undefined || packedState.packedList.length === 0; else withData">
        <div class="sinDatos">
            <mat-icon class="customIconSize">grid_off</mat-icon>
            <span class="sinDatosTexto" i18n="@@PackageOrder.noItemsPacked">Items not packed</span>
        </div>
    </ng-container>
    <ng-template #withData>
        <app-order-table [orderLines]="packedState.packedList | sortOrderLinePackedVo"
            (onSelected)="onChangeSelected($event)" [itemStyle]="orderTableStyle.Packed"
            class="orderList packedList"></app-order-table>
    </ng-template>
</mat-expansion-panel>

<footer class="main-footer">
</footer>

<app-scroll-top></app-scroll-top>